import { render } from "./Carousel.vue?vue&type=template&id=02af4bf2"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"
script.render = render

export default script